import { makeCoordKey } from './makeCoordKey';
import type { SpiderEntry } from './markerSpider.types';

export function clusterSpiderEntriesByEqualCoordinate(
  entries: ReadonlyArray<SpiderEntry>
): SpiderEntry[][] {
  if (entries.length === 0) {
    return [];
  }
  const buckets = new Map<string, SpiderEntry[]>();
  for (const entry of entries) {
    const key = makeCoordKey(entry.latitude, entry.longitude);
    const existing = buckets.get(key);
    if (existing) {
      existing.push(entry);
      continue;
    }
    buckets.set(key, [entry]);
  }
  return Array.from(buckets.values());
}
